import { getApiBaseUrl } from "../config/apiBase";
import { apiFetch } from "../config/apiFetch";
import type { GeoDirectoryPayload } from "../data/geoDirectoryStore";

/** Loads district → mandal → village tree from `geo_directory_*` tables via the API. */
export async function fetchGeoDirectory(): Promise<GeoDirectoryPayload> {
  const base = getApiBaseUrl();
  const res = await apiFetch(`${base}/api/geo/directory`);
  if (res.ok) {
    return res.json() as Promise<GeoDirectoryPayload>;
  }
  let detail = `status ${res.status}`;
  try {
    const text = await res.text();
    const j = JSON.parse(text) as { error?: string; hint?: string };
    if (j.error) detail = j.error;
    if (j.hint) detail += `. ${j.hint}`;
  } catch {
    /* ignore */
  }
  throw new Error(`Geo directory API unavailable (${detail}). Ensure geo_directory tables are seeded in the database.`);
}
